<header>
  <div class="logo">

    <span>C</span>
    <span>C</span>
    <span>I</span>

  </div>
  <div>
    <ng-container *ngIf="isLoggedIn; else loggedOutTemplate">
      <span class="username">Olá, {{ userName }} </span> &nbsp;
      <button mat-button (click)="logout()" class="btn-shimmer">Logout</button>
    </ng-container>

    <ng-template #loggedOutTemplate>
      <button (click)="login()">Login</button>
    </ng-template>
  </div>

</header>
<main>
 
  <router-outlet></router-outlet>
  
  <app-global-loading></app-global-loading>
</main>
<footer></footer>